import {FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST,FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED, FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED} from "../actions/actionTypes";
import {
  FetchWopiAssetDetailsRequest,
  FetchWopiAssetDetailsResponse,
  FetchWopiAssetDetailsErrorResponse
} from "../../types/microsoftWopiIntegration";
import { UnknownAction } from "redux-saga";

import _ from "lodash";


interface WopiIntegrationState {
  loading: boolean,
  item: FetchWopiAssetDetailsResponse | null,
  error: {
    code: number | null,
  },
  asset: {
    updating: boolean,
    processed: boolean,
    item: null,
    error: null
  },
};

const initialState: WopiIntegrationState = {
  loading: false,
  item: null,
  error: {
    code: null,
  },
  asset: {
    updating: false,
    processed: false,
    item: null,
    error: null
  },
};  

type Action = UnknownAction;

export function microsoftWopiIntegrationReducer(
  state: WopiIntegrationState  = initialState,
  action: Action,
): WopiIntegrationState {
  switch (action.type) {
    case FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED:
      const response = action.payload as FetchWopiAssetDetailsResponse;
      return {
        ...state,
        loading: false,
        item: response
      };

    case FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED:
      const {error} = action.payload as FetchWopiAssetDetailsErrorResponse;
      return {
        ...state,
        loading: false,
        item: null,
        error: error
      };  

    default:
      return state;
  } 
}